import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import ChatSidebar from '@/components/layout/ChatSidebar';
import ChatHeader from '@/components/layout/ChatHeader';

export default function ChatLayout() {
  useKeyboardShortcuts();

  return (
    <SidebarProvider>
      <ChatSidebar />
      <SidebarInset>
        <ChatHeader />
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
